export const TOP_BANNER_HEIGHT = 32;
export const NAVBAR_HEIGHT = {
  normal: 72,
  scrolled: 60,
  checkout: 64,
};
export const SCROLL_THRESHOLD = 20;
export const SEARCH_FIELD_WIDTH = "100%";
export const SEARCH_FIELD_HEIGHT = 36;
export const LOGO_SIZE = {
  normal: 44,
  scrolled: 36,
};
export const BADGE_SIZE = 18;














